import { StyleProp, ViewStyle } from 'react-native';
import { G, Path, Svg } from 'react-native-svg';
import { nativewindWrapSvg } from './wrapSvg';

function InfoIconRaw({
  style,
  fill,
}: {
  style?: StyleProp<ViewStyle>;
  fill?: string;
  className?: string;
}) {
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill={fill} style={style}>
      <G>
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.582031 7.99967C0.582031 3.91879 3.91782 0.583008 7.9987 0.583008C12.0796 0.583008 15.4154 3.91879 15.4154 7.99967C15.4154 12.0806 12.0796 15.4163 7.9987 15.4163C3.91782 15.4163 0.582031 12.0806 0.582031 7.99967ZM7.9987 2.08301C4.74624 2.08301 2.08203 4.74722 2.08203 7.99967C2.08203 11.2521 4.74624 13.9163 7.9987 13.9163C11.2512 13.9163 13.9154 11.2521 13.9154 7.99967C13.9154 4.74722 11.2512 2.08301 7.9987 2.08301ZM7.9987 6.58301C8.41291 6.58301 8.7487 6.91879 8.7487 7.33301V10.6663C8.7487 11.0806 8.41291 11.4163 7.9987 11.4163C7.58448 11.4163 7.2487 11.0806 7.2487 10.6663V7.33301C7.2487 6.91879 7.58448 6.58301 7.9987 6.58301ZM7.99479 4.33301C7.44251 4.33301 6.99479 4.78072 6.99479 5.33301C6.99479 5.88529 7.44251 6.33301 7.99479 6.33301H8.00078C8.55306 6.33301 9.00078 5.88529 9.00078 5.33301C9.00078 4.78072 8.55306 4.33301 8.00078 4.33301H7.99479Z"
          fill={fill}
        />
      </G>
    </Svg>
  );
}

export const InfoIcon = nativewindWrapSvg(InfoIconRaw);
